import { InputProps } from 'antd';
import clx from 'classnames';
import React from 'react';
import { RichTextMenuRow } from './menu/RichTextMenuRow';
import { StyledMenuBarWrapper } from './style/StyledMenuBarWrapper';
import { StyledRteContainer } from './style/StyledRteContainer';
import { StyledRteEditor } from './style/StyledRteEditor';

export interface RichTextInputWrapperProps {
  menuBar?: React.ReactNode;
  children: React.ReactNode;
  size?: InputProps['size'];
  disabled?: boolean;
  /*
   * Per l'inserimento di elementi extra al menu
   * che saranno posizionati a destra del menu.
   */
  extra?: React.ReactNode;
  /*
   * Numero di righe da mostrare nel campo di input.
   */
  rows?: number;
  /*
   * Altezza massima del campo di input.
   */
  maxHeight?: number;

  className?: string;
}

export function RichTextInputWrapper(props: RichTextInputWrapperProps) {
  const { menuBar, children, size, rows, maxHeight, disabled, extra } = props;
  const minHeight =
    (size == 'large' ? 24 : size == 'small' ? 18 : 21) * (rows ?? 2);
  return (
    <StyledRteContainer
      className={clx(props.className, {
        'rte-container-lg': size == 'large',
        'rte-container-sm': size == 'small',
      })}
    >
      {!!menuBar && (
        <StyledMenuBarWrapper
          className={clx({
            'rte-menu-wrapper-lg': size == 'large',
            'rte-menu-wrapper-sm': size == 'small',
          })}
        >
          <RichTextMenuRow extra={extra}>{menuBar}</RichTextMenuRow>
        </StyledMenuBarWrapper>
      )}
      <StyledRteEditor
        minHeight={minHeight}
        maxHeight={maxHeight}
        className={clx('rte-input-editor', {
          'rte-input-disabled': disabled,
          'rte-input-lg': size == 'large',
          'rte-input-sm': size == 'small',
          'rte-input-has-menu-bar': !!menuBar,
        })}
      >
        {children}
      </StyledRteEditor>
    </StyledRteContainer>
  );
}
